import useOrdinationStore from "../store/ordinationStore";

const Ordination = ({ field }: { field: string }) => {
  const currentOrder = useOrdinationStore((state) => state.currentOrder);
  const fieldOrder = useOrdinationStore((state) => state.fieldOrder);
  const setCurrentOrder = useOrdinationStore((state) => state.setCurrentOrder);
  const setFieldOrder = useOrdinationStore((state) => state.setFieldOrder);

  const handleOrder = (field: string) => {
    if (fieldOrder === field) {
      setCurrentOrder(currentOrder === "asc" ? "desc" : "asc");
    } else {
      setCurrentOrder("asc");
      setFieldOrder(field);
    }
  };

  return (
    <span onClick={() => handleOrder(field)}>
      {fieldOrder === field ? (
        currentOrder === "asc" ? (
          <img
            src="/assets/icons/sort-order-up-16.png"
            style={{ width: "12px", height: "12px" }}
            alt="Order up"
          />
        ) : (
          <img
            src="/assets/icons/sort-order-down-16.png"
            style={{ width: "12px", height: "12px" }}
            alt="Order down"
          />
        )
      ) : (
        <img
            src="/assets/icons/sort-order-16.png"
            style={{ width: "12px", height: "12px" }}
            alt="Order"
        />
      )}
    </span>
  );
};

export default Ordination;
